export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4040eac47d95d25e24968a1293d34f68df5108d54a&name=addToFolderEventAction!'